import { styled } from '@mui/material/styles';

export const Title = styled('div')<{ name: string }>`
  font-size: 15px;
  padding-top: ${(props) => (props.name ? '10px' : '30px')};
  width: 100%;
  color: ${(props) => props.theme.palette.primary.main};
`;

export const Description = styled('div')`
  font-size: 16px;
  padding-bottom: 10px;
  width: 100%;
  color: ${(props) => props.theme.palette.text.primary};
`;

export const ClickableDiv = styled('div')<{ isClickable: boolean }>`
  cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};
  ${(props) =>
    props.isClickable &&
    `
    & > .field-value {
      width: auto;
      border: 1px solid ${props.theme.palette.divider};
      min-height: 26px;
      border-radius: 7px;
      padding: 4px;
    }
    background-color:  ${props.theme.palette.background.default}50;
    &:hover {
      background-color: ${props.theme.palette.action.hover};
  }`}
`;
